import SeoPageLayout from "@/components/SeoPageLayout";

const WystepKabaretowyRadom = () => (
  <SeoPageLayout title="Występ kabaretowy Radom - humor na każdą okazję">
    <p>
      Radom, jedno z największych miast centralnej Polski, oferuje świetne warunki na organizację wydarzeń firmowych. Występ kabaretowy w Radomiu to sprawdzona atrakcja, która urozmaici każdy event - od spotkania firmowego po wielką galę.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Kabaret na eventy firmowe w Radomiu</h2>
    <p>
      Przyjeżdżamy do Radomia z profesjonalnym programem kabaretowym. Występujemy w hotelach, centrach konferencyjnych i restauracjach na terenie miasta. Materiał dopasowujemy do branży i typu wydarzenia.
    </p>

    <h2 className="text-2xl font-bold text-foreground mt-10">Gdzie występujemy w Radomiu?</h2>
    <ul className="list-disc pl-6 space-y-2">
      <li>Hotele i centra konferencyjne - profesjonalne eventy</li>
      <li>Restauracje i sale bankietowe - kameralne spotkania</li>
      <li>Obiekty na obrzeżach - integracje i pikniki firmowe</li>
      <li>Sale widowiskowe - duże wydarzenia i gale</li>
    </ul>

    <h2 className="text-2xl font-bold text-foreground mt-10">Profesjonalny kabaret blisko Warszawy</h2>
    <p>
      Radom leży w dogodnej lokalizacji - blisko Warszawy, ale z własnym, niepowtarzalnym charakterem. Firmy z Radomia i okolic mogą liczyć na profesjonalną obsługę kabaretową na najwyższym poziomie, bez konieczności zamawiania artystów z odległych miast.
    </p>
  </SeoPageLayout>
);

export default WystepKabaretowyRadom;
